<template>
  <div>
    <OnboardingTextSection>
      Если вам нужно подключить рекламные площадки<br>
      или системы аналитики, используйте вкладку<br>
      «Привязки». Эта вкладка есть в любом аккаунте.
    </OnboardingTextSection>

    <OnboardingImageSection
      :image="mascotSpeaking"
      width="135px"
      align="center"
    />
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';
  import OnboardingImageSection from 'onboarding/onboardings/components/OnboardingImageSection';

  import mascotSpeaking from 'assets/mascot/mary-speaking.png';

  export default {
    name: 'ConnectionsTabStep',
    components: {OnboardingImageSection, OnboardingTextSection},
    data () {
      return {
        mascotSpeaking
      };
    }
  };
</script>
